import { render } from "./blessing.vue?vue&type=template&id=35deba5b"
import script from "./blessing.vue?vue&type=script&lang=js"
export * from "./blessing.vue?vue&type=script&lang=js"

import "./blessing.vue?vue&type=style&index=0&id=35deba5b&lang=less"

import exportComponent from "/Users/Learning/Documents/Workspace/VSCode/HTML/_GitHub/shenwedding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__